<template>
  <div class="auth-sidebar">
    <div ref="header" class="booking-header-extension" data-component="booking-fans-flyout-header">
      <div data-component="booking-header-close" class="booking-header-close" :class="[{ 'show-both': backArrow }]">
        <span class="icon-arrow-back" :aria-label="tc('booking.back')" tabindex="0" @click="getBack" @keypress.enter.prevent="getBack"
        @keypress.space.prevent="getBack"></span>
        <span class="icon-close" :aria-label="tc('booking.close')" tabindex="0" @click="closeModal" @keypress.enter.prevent="closeModal"
        @keypress.space.prevent="closeModal"></span>
      </div>
      <div class="booking-header-extension-wrapper container">
        <div class="booking-header-extension-left">
          <div id="cart-overview-title" class="title">{{tc('auth.sidebarTitle')}}</div>
        </div>
      </div>
    </div>
    <div
    class="auth-sidebar-scroll"
    data-component="booking-fans-flyout-body"
    :style="[{ height: scrollHeight + 'px' }]">
      <transition name="fade">
        <component
          :is="componentName"
          @change-component="currentComponent = $event"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import TabTrapMixin from '@mixins/tab-trap'
import { capitalize } from '@utils/string-helpers'
import SidebarLogin from './components/sidebar-login.vue'
import SidebarRegistration from './components/sidebar-registration.vue'
import HeaderClose from '../../04.booking/booking-widget/components/header-close/header-close.vue'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'auth-sidebar',
  components: {
    SidebarLogin,
    SidebarRegistration,
    HeaderClose
  },
  mixins: [TabTrapMixin],
  props: {
    defaultComponent: {
      type: String,
      default: 'login'
    },
    backArrow: Boolean,
    deactivate: {
      type: Function
    },
  },
  data: () => ({
    currentComponent: null,
    scrollHeight: 'auto'
  }),
  computed: {
    ...mapGetters('i18n', ['tc']),
    ...mapState('responsive', { wHeight: 'height', wWidth: 'width' }),
    ...mapGetters('auth', ['haveProfileData']),
    componentName() {
      return `Sidebar${capitalize(this.currentComponent || this.defaultComponent)}`
    },
  },
  watch: {
    wWidth() {
      this.calculateHeight()
    },
    haveProfileData(val) {
      if (val) {
        this.$emit('auth-done')
      }
    }
  },
  created() {
    this.currentComponent = this.defaultComponent
  },
  mounted() {
    if (this.haveProfileData) {
      this.$emit('back')
    }
    this.calculateHeight()
  },
  methods: {
    closeModal() {
      if(this.deactivate) {
        this.deactivate()
      } else {
        this.$emit('close')
      }
      
    },
    getBack() {
      this.$emit('back')
    },
    calculateHeight() {
      const headerHeight = this.$refs.header.getBoundingClientRect().height
      this.scrollHeight = this.wHeight - headerHeight
    }
  }
}
</script>